import { json } from "stream/consumers";
import { FTYPE } from "./consts";

export function normalizeHeader(header: string) {
    header = header.toLowerCase();
    header = header.replace('_', " ");
    let words = header.split(' ').map(value => value[0].toUpperCase() + value.substring(1))
    return words.join(" ");
}


export function filename2Path(filename: string | undefined, filetype: FTYPE) {

    if (!filename) {
        return "";
    }

    const methods = ["Bayesian", "Poisson", "SN"];

    const [part_mm, part_date, part_hour, part_num] = filename.split('_');

    let method_folder = "";
    const char_1 = part_mm.charAt(0);
    if (char_1 === "B") {
        method_folder = methods[0];
    } else if (char_1 === "P") {
        method_folder = methods[1];
    } else if (char_1 === "S") {
        method_folder = methods[2];
    }

    const char_2 = part_mm.charAt(1);
    const mode_folder = `Mode_${char_2}`;


    const date_folder = part_date;


    if (filetype === FTYPE.JSON) {
        return [method_folder, mode_folder, date_folder, filename + FTYPE.JSON].join("/");
    } else {
        return [[method_folder, mode_folder, date_folder, [part_mm, part_date, part_hour, "12det", part_num].join("_") + FTYPE.PDF].join("/"),
        [method_folder, mode_folder, date_folder, [part_mm, part_date, part_hour, "8cha", part_num].join("_") + FTYPE.PDF].join("/")]
    }

}